module.exports = "../../app/cells/components/start_now_cell.rb";